
const button = {
  text: {
    submit: 'Enviar',
    cancel: 'Cancelar',
    clearFilter: 'Limpar filtros',
    close: 'Fechar',
    create: 'Criar',
    edit: 'Editar',
    save: 'Editar',
  },
};

export default button;
